import { finalize, Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpConfirmationService } from '../../service/http-confirmation.service';
import { AgentConfirmationDto } from '../../service/dto';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-agent-edit-confirmation',
  standalone: false,
  templateUrl: './agent-edit-confirmation.component.html',
  styleUrl: './agent-edit-confirmation.component.scss'
})
export class AgentEditConfirmationComponent implements OnInit, OnDestroy {
	subscription = new Subscription();
	loading = false;
	confirmation?: AgentConfirmationDto;
	submitting: boolean = false;
	message?: string;
	form!: FormGroup;



	constructor(private fb: FormBuilder, private activatedRoute: ActivatedRoute, private service: HttpConfirmationService) {
	}
	ngOnInit(): void {
		this.subscription.add(
			this.activatedRoute.queryParamMap.subscribe(params => {
				if (params.get('code')) {
					this.loading = true;
					this.service.findByCode(params.get('code')!)
						.pipe(finalize(() => this.loading = false))
						.subscribe(result => this.confirmation = result);
				} else if (params.get('id')) {
					this.loading = true;
					this.service.findById(+params.get('id')!)
						.pipe(finalize(() => this.loading = false))
						.subscribe(result => this.confirmation = result);
				} else {
					this.confirmation = undefined;
				}
				this.form = this.fb.group({
					otp: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]]
				});
			})
		);
	}
	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	decline(){
		this.submitting=true;
		this.service.decline(this.confirmation!.id, this.form.get('otp')!.value)
						.pipe(finalize(() => this.submitting = false))
						.subscribe(result => this.confirmation = result);
	}
	accept(){
		this.submitting=true;
		this.service.accept(this.confirmation!.id, this.form.get('otp')!.value)
						.pipe(finalize(() => this.submitting = false))
						.subscribe(result => this.confirmation = result);
	}
}
